module.exports = __webpack_public_path__ + "static/media/fuelGray.e1044401.svg";